import { DateTime } from 'luxon';

declare global {
    interface String {
        removerHTML(): string;
        cortar(limite: number): string;
        data(): DateTime;
        slug(): string;
        moeda(): string;
    }
}

String.prototype.removerHTML = function()
{
    return this.replace(/(<([^>]+)>)/ig,'');
}

String.prototype.cortar = function(limite: number): string
{
    const texto = String(this);

    if (texto.length >= limite) {
        return texto.substring(0, limite) + '...';
    }

    return texto;
}

String.prototype.data = function(): DateTime
{
    return DateTime.fromISO(String(this)).setLocale('br');
}

String.prototype.slug = function (): string
{
    return this.toString().toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')
        .replace(/[èÈéÉêÊëË]+/g, 'e')
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i')
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u')
        .replace(/[ýÝÿŸ]+/g, 'y')
        .replace(/[ñÑ]+/g, 'n')
        .replace(/[çÇ]+/g, 'c')
        .replace(/[ß]+/g, 'ss')
        .replace(/[Ææ]+/g, 'ae')
        .replace(/[Øøœ]+/g, 'oe')
        .replace(/[%]+/g, 'pct')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

String.prototype.moeda = function()
{
    return `R$: ${new Number(this).toFixed(2)}`;
}
